/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import { FieldPageLayout } from 'src/app/graph/insights/fieldPage/FieldPageLayout';
import { InsightsExpandButton } from 'src/app/graph/insights/InsightsExpandButton';
import { useInsightsL3NavState } from 'src/app/graph/operationsPage/insightsL3Nav/useInsightsL3NavState';
import { coordinateNotFoundRouteConfig } from 'src/app/graph/routes';
import { raw as ImageSatellite } from 'src/assets/satellite.svg';
import { PageTitle } from 'src/components/common/pageTitle/PageTitle';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { useRouteParams } from 'src/hooks/useRouteParams';
import { CoordinateKind } from 'src/lib/graphqlTypes/types';

const titleByCoordinateKind = new Map<CoordinateKind, string>([
  [CoordinateKind.ENUM_VALUE, 'No Enum Values Found'],
  [CoordinateKind.INPUT_OBJECT_FIELD, 'No Input Fields Found'],
  [CoordinateKind.OBJECT_FIELD, 'No Fields Found'],
]);

export const CoordinateNotFoundPage = () => {
  const { isOpen, onOpen } = useInsightsL3NavState();
  const { coordinateKind = CoordinateKind.OBJECT_FIELD } = useRouteParams(
    coordinateNotFoundRouteConfig,
  );

  return (
    <FieldPageLayout>
      <div className="relative flex flex-1 flex-col bg-primary">
        <div className="bg-primary px-8 pb-24">
          <div className="sticky top-0 z-10 bg-primary pt-4">
            <PageTitle
              title=""
              className="border-b-0 px-[0px]"
              leftAdornment={
                !isOpen ? (
                  <Tooltip label="Expand">
                    <InsightsExpandButton onOpen={onOpen} />
                  </Tooltip>
                ) : null
              }
            />
          </div>
        </div>
        <div className="flex items-center justify-center">
          <div className="max-w-md text-center">
            <img className="mb-10" src={ImageSatellite} alt="satellite" />
            <div className="mb-4 text-2xl font-semibold">
              {titleByCoordinateKind.get(coordinateKind)}
            </div>
            <div>Try resetting your filters to see more results</div>
          </div>
        </div>
      </div>
    </FieldPageLayout>
  );
};
